var ACOM = window.ACOM || (function ($) {
        'use strict';

        var _this = {};

        _this.mobile = false;
        _this.elementsMoved = false;
        _this.navigationMoved = false;
        _this.navigationOpened = false;
        _this.resizing = false;
        _this.navigationWrapper;
        _this.navigation;
        _this.searchForm;
        _this.pageContent;
        _this.searchTrigger;
        _this.overlay;
        _this.navigationTrigger;
        _this.mainHeader;
        _this.settings = {}
        _this.helper = {}

        var init = function (settings, helper) {
            _this.settings = settings
            _this.helper = helper
            _this.header = new acom_app.views.Header();
            _this.search = new acom_app.views.Search();
            _this.panel = new acom_app.views.Panel();
            _this.styles = new acom_app.views.Styles();

            close();
            prepare();
            moveElements();

            initStyles();
            initFonts();

            setTimeout(function () {
                initHeader();
                initSearch();
                initPanel();
                initLogin();
                initSubscribe();
                initVars();
                resize();
                bindScroll();
                bindEvents()

                closeNavigation()

                if (!window.ACOM_INITIALIZED) {
                    window.ACOM_INITIALIZED = true
                }
            }, 0)
        }

        var resize = function () {
            $(window).off('resize.acom')
            $(window).on('resize.acom', checkResize).trigger('resize.acom')
        }

        var close = function () {
            var $trigger = _this.settings.get('styles.hidden_trigger')

            $('.cd-main-header').remove()
            $('.cd-panel-wrapper').remove()

            $(document).off('click.acom', $trigger)
            $(document).off('click.acom', '.acom-overlay')
            $(document).off('scroll.acom')
        }

        var prepare = function () {
            var treshold = !!+_this.settings.get('styles.menu_mobile_treshold') ? +_this.settings.get('styles.menu_mobile_treshold') : 0;
            _this.mobile = AC_isMobile.any || document.body.clientWidth < treshold ? true : false;
            _this.mode = _this.settings.get('styles.general_mode');
            _this.mobile = _this.mode == 'button' ? true : _this.mobile;


            var modeClass = 'acom-' + _this.mode

            var mobileClass = _this.mobile ? 'acom-mobile' : 'acom-desktop';
            var fixedClass = function () {
                var c = 'acom-static';
                if (
                    (!!+_this.settings.get('styles.menu_fixed') && _this.mode == 'menu') ||
                    (!!+_this.settings.get('styles.button_fixed') && _this.mode == 'button')
                ) {
                    c = 'acom-fixed'
                }
                return c;
            }

            var transparentClass = !!+_this.settings.get('styles.menu_transparent') ? 'acom-transparent' : 'acom-solid';
            var pushedClass = !!+_this.settings.get('styles.menu_push') ? 'acom-pushed' : '';
            var searchModeClass = _this.settings.get('styles.search_button_type') == 'button' ? 'acom-search-button' : 'acom-search-field';

            if(_this.mode == 'hidden'){
                var target = _this.settings.get('styles.hidden_target');
                modeClass += ' acom-' + target

                if(target == 'menu'){
                    pushedClass = ''
                }
            }

            _this.settings.set('styles.mobile', _this.mobile);

            $.fn.stripClass = function (partialMatch, endOrBegin) {
                var x = new RegExp((!endOrBegin ? "\\b" : "\\S+") + partialMatch + "\\S*", 'g');

                this.attr('class', function (i, c) {
                    if (!c) return; // protect against no class
                    return c.replace(x, '');
                });
                return this;
            };

            $("html").stripClass('acom-');

            $('html')
                .addClass(modeClass)
                .addClass(fixedClass)
                .addClass(mobileClass)
                .addClass(pushedClass)
                .addClass(transparentClass)
                .addClass(searchModeClass);

            //add the .no-pointerevents class to the <html> if browser doesn't support pointer-events property
            ( !Modernizr.testProp('pointerEvents') ) && $('html').addClass('no-pointerevents');
        }

        var initVars = function () {
            _this.navigationWrapper = $('.cd-main-nav-wrapper');
            _this.navigation = _this.navigationWrapper.children('.cd-main-nav');
            _this.logo = $('.cd-logo');
            _this.searchForm = $('.cd-main-search');
            _this.pageContent = $('.cd-main-content');
            _this.searchTrigger = $('.cd-search-trigger');
            _this.overlay = $('.acom-overlay');
            _this.navigationTrigger = $('.cd-nav-trigger');
            _this.mainHeader = $('.cd-main-header');
            _this.status = _this.mobile ? 'mobile' : 'desktop'
        }

        var initHeader = function () {
            _this.header.render();
        }
        var initSearch = function () {
            _this.search.render();
        }
        var initPanel = function () {
            _this.panel.render();
        }
        var initLogin = function () {
            _this.login = new acom_app.views.Login();
            _this.login.render();
        }
        function initSubscribe() {
            _this.subscribe = new acom_app.views.Subscribe();
            _this.subscribe.render();
        }
        var initStyles = function () {
            _this.styles.render();
        }

        var moveElements = function () {
            if (_this.elementsMoved) return;

            var $childs = $('body > *');
            var $div = $('<div class="cd-main-content"></div>');
            $childs.each(function (i, el) {
                if ($(el).attr('id') != 'wpadminbar') {
                    $(el).detach().appendTo($div);
                }
            });
            $('body').append($div);
            _this.elementsMoved = true;
        }

        function checkResize() {
            prepare();
        }

        var openSearchForm = function () {
            var $searchForm = $('.cd-main-search');
            var trigger_mode = _this.settings.get('styles.search_button_type')

            $('#cd-search-results').html('')
            $('.cd-main-search input[type="search"]').val('');

            if ($('.cd-search-trigger').hasClass('search-form-visible') && trigger_mode == 'button') {
                $searchForm.find('form').submit();
            } else {
                $('.cd-search-trigger').addClass('search-form-visible');
                _this.mainHeader.addClass('search-is-visible');
                $searchForm.addClass('is-visible').one('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend', function () {
                    $searchForm.find('input[type="search"]').focus().end().off('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend');
                });
            }
        }

        var closeSearchForm = function closeSearchForm() {
            $('.cd-search-trigger').removeClass('search-form-visible');
            _this.mainHeader.removeClass('search-is-visible');
            $('.cd-main-search').removeClass('is-visible');
        }

        var toggleNavigation = function (e) {
            e.preventDefault();
            if (_this.navigationOpened) {
                closeNavigation(e)
            } else {
                openNavigation(e);
            }
        }

        var openNavigation = function (e) {
            _this.navigationOpened = true;

            $('html').addClass('acom-panel-visible')
        }

        var closeNavigation = function () {
            _this.navigationOpened = false;

            $('html').removeClass('acom-panel-visible')
        }

        var initFonts = function () {
            var fields = [
                'button_text_family',
                'menu_logo_text_family',
                'menu_menu_text_family',
                'panel_menu_text_family',
                'search_menu_text_family',
                'search_results_text_family',
            ];
            var fonts = [];
            _.each(fields, function (val, i) {
                var font = _this.settings.get('styles.' + val)

                if (font == 'inherit') return
                fonts.push(font);
            });

            if (fonts.length === 0) return

            WebFont.load({
                google: {
                    families: fonts
                }
            });
        }

        var bindScroll = function () {
            //if (window.ACOM_INITIALIZED) return
            var transp_mode = !!+_this.settings.get('styles.menu_transparent')
            var adaptive_mode = !!+_this.settings.get('styles.menu_adaptive_height')

            var adaptive_treshold = +_this.settings.get('styles.menu_adaptive_height_treshold') ? +_this.settings.get('styles.menu_adaptive_height_treshold') : 0;
            var fixed_treshold = +_this.settings.get('styles.menu_fixed_treshold') ? +_this.settings.get('styles.menu_fixed_treshold') : 0;
            var transp_treshold = +_this.settings.get('styles.menu_transparent_treshold') ? +_this.settings.get('styles.menu_transparent_treshold') : 0;

            if (_this.mode == 'menu' && fixed_treshold > 0) {
                $(document).on('scroll.acom', function () {
                    var scroll = $(window).scrollTop()
                    _this.mainHeader.removeClass('visible')

                    if (scroll > fixed_treshold) {
                        _this.mainHeader.addClass('visible')
                    }
                }).trigger('scroll')
            }

            if (transp_mode && transp_treshold > 0) {
                $(document).on('scroll.acom', function () {
                    var scroll = $(window).scrollTop()
                    $('html')
                        .addClass('acom-transparent')
                        .removeClass('acom-solid')

                    if (scroll > transp_treshold) {
                        $('html')
                            .removeClass('acom-transparent')
                            .addClass('acom-solid')
                    }
                }).trigger('scroll')
            }

            if (adaptive_mode && adaptive_treshold > 0) {
                $(document).on('scroll.acom', function () {
                    var scroll = $(window).scrollTop()
                    $('html')
                        .removeClass('acom-adaptive-height')
                    if (scroll > adaptive_treshold) {
                        $('html')
                            .addClass('acom-adaptive-height')
                    }
                }).trigger('scroll')
            }

            if(_this.mode == 'menu' && _this.mobile){
                $(window).on('scroll.acom resize.acom', function () {
                    var scroll = $(window).scrollTop()
                    var height = jQuery(window).height()

                    if(!$('body').hasClass('admin-bar')) return

                    if(jQuery(window).width() <= 600){
                        if(scroll <= 46){
                            $('.cd-main-header').css('top', 46 - scroll)
                            $('.cd-panel-wrapper').css('top', 50 + 46 - scroll)
                            $('.cd-panel-wrapper').css('height', height - 50 - scroll)
                        }else{
                            $('.cd-main-header').css('top', 0)
                            $('.cd-panel-wrapper').css('top', 50)
                            $('.cd-panel-wrapper').css('height', height - 50)
                        }
                    }else{
                        $('.cd-main-header').css('top', '')
                        $('.cd-panel-wrapper').css('top', '')
                        $('.cd-panel-wrapper').css('height', '')
                    }
                }).trigger('scroll').trigger('resize')
            }

        }

        var bindEvents = function () {
            var $trigger = _this.settings.get('styles.hidden_trigger')
            var target = _this.settings.get('styles.hidden_target')

            $(document).on('click.acom', '.acom-overlay', closeNavigation)



            if (_this.mode == 'hidden') {
                $(document).on('click.acom', $trigger, function (e) {

                    if ($trigger == '') return

                    $('html').toggleClass('acom-revealed')

                    if(target == 'panel'){
                        toggleNavigation(e)
                    }
                })
            }
        }

        return {
            init: init,
            prepare: prepare,
            resize: resize,
            initHeader: initHeader,
            initStyles: initStyles,
            initSearch: initSearch,
            initFonts: initFonts,
            toggleNavigation: toggleNavigation,
            openNavigation: openNavigation,
            closeNavigation: closeNavigation,
            openSearchForm: openSearchForm,
            closeSearchForm: closeSearchForm,
        };
    })(jQuery);

jQuery(document).ready(function () {
    var settings = acom_app.models.settings
    var helper = acom_app.models.helper

    setTimeout(function () {
        if (
            AC_isMobile.any && !!+settings.get('general.display_mobile') ||
            !AC_isMobile.any && !!+settings.get('general.display_desktop')
        ) {
            ACOM.init(settings, helper);
        }
    }, 0)
});